import {
  BANNER_TYPE_ERROR,
  BANNER_TYPE_SUCCESS,
  BANNER_TYPE_WARNING,
  SHIPPING_DETAILS
} from "../../util/ConfigConstants";
import {AppConfig, AppConfigMapKey} from "../config/AppConfig";

export const CONFIGURATION_TYPE_COLUMN_INFO =
  {
    label: "Configuration Type",
    name: "ConfigurationType",
    description: "Choose the type of Configuration record to access"
  };

export const TABLE = {
  THROUGHPUT_CONSTRAINT_ID: "Constraints",
  THROUGHPUT_CONSTRAINT_HEADER: "Throughput Inputs",
  SITE_SPREAD_CONSTRAINT_ID: "SiteSpreadConstraints",
  SITE_SPREAD_CONSTRAINT_HEADER: "Site Spread Table",
  DAY_COLUMN: {
    ID: "Day",
    HEADER: "Day"
  },
  SITE_MAX: {
    ID: "SiteMax",
    HEADER: "Site Max"
  },
  SITE_SPREAD_MAX: {
    ID: "SiteSpreadMax",
    HEADER: "Site Spread Max"
  },
  AZ_MAX: {
    ID: "AzMax",
    HEADER: "Az Max"
  },
  CROSSDOCK: {
    ID: "stopName",
    HEADER: "Cross Dock"
  },
  MOT_FOR_CROSS_DOCK: {
    ID: "preferredMot",
    HEADER: "MOT For Cross Dock"
  }
}

export const DOES_NOT_EXIST = "-";
export const STATUS_CODE = {
  SUCCESS: 200,
  VALIDATION_FAILURE: 400
}
export const ERROR_TYPE = {
  FATAL: "FATAL",
  WARNING: "WARNING"
}

export const FLEX_DAYS_COLUMN_INFO = {label: "Flex Days", name: "FlexDays"};
export const SORTING_ORDER_COLUMN_INFO = {label: "Sorting Order", name: "SortingOrder"};
export const LOCATION_NAME_COLUMN_INFO ={label: "Location Name", name: "LocationName"};
export const LOCATION_TYPE_COLUMN_INFO ={label: "Location Type", name: "LocationType"};
export const HOLIDAY_NAME_COLUMN_INFO ={label: "Holiday Name", name: "HolidayName"};
export const EFFECTIVE_FROM_COLUMN_INFO ={label: "Effective From", name: "EffectiveFrom"};
export const EFFECTIVE_TO_COLUMN_INFO ={label: "Effective To", name: "EffectiveTo"};
export const DISABLE_COLUMN_INFO ={id: "Disable", header: "Disable"};
export const CREATED_AT_COLUMN_INFO ={id: "CreatedAt", header: "Updated At"};
export const CREATED_BY_COLUMN_INFO ={id: "CreatedBy", header: "Updated By"};
export const HOLIDAY_TYPE_COLUMN_INFO ={label: "Holiday Type", name: "HolidayType"};
export const HOLIDAY_CATEGORY_COLUMN_INFO ={label: "Holiday Category", name: "HolidayCategory"};
export const RECURRING_HOLIDAYS_COLUMN_INFO ={label: "Weekly Blocked Days", name: "RecurringHolidays"};

export const CROSS_DOCKS_ID = "Stops";
export const CROSS_DOCKS_HEADER = "Cross Docks";
export const CONDITIONAL_ATTRIBUTE_KEY = "ConditionalAttributeKey";
export const CONDITIONAL_ATTRIBUTE_KEY_DELIMITER = "_";
export const ROUTE_TYPE_COLUMN_INFO = {label: "Route Type", name: "RouteType", description: "It is mandatory input for route."};
export const SOURCE_LOCATION_COLUMN_INFO = {
  TYPE: {label: "Source Location Type", name: "SourceLocationType", description: "Choose the Source Location Type for the route"},
  NAME: {label: "Source Location Name", name: "SourceLocationName", description: "Options will depend upon the Source Location Type"},
  IS_HOZ: {label: "", name: "isHozLocation", description: "The Selected Location is Hoz Site/Zone"}
}
export const DESTINATION_LOCATION_COLUMN_INFO = {
  TYPE: {label: "Destination Location Type", name: "DestinationLocationType", description: "Choose the Destination Location Type for the route"},
  NAME: {label: "Destination Location Name", name: "DestinationLocationName", description: "Options will depend upon the Destination Location Type"}
}

export const SOURCE_LOCATION_ID = {label: "Source Location Id", name: "SourceLocationId"}
export const DESTINATION_LOCATION_ID = {label: "Destination Location Id", name: "DestinationLocationID"}
export const PROGRAM_TYPE_COLUMN_INFO = {label: "Program Type", name: "ProgramType", description: "Choose the Program Type for the route"};
export const LAST_LEG_MOT_COLUMN_INFO = {label: "Last Leg MOT", name: "LastLegMOT", description: "Choose the Last Leg MOT for the route"};
export const ROUTE_PROPERTIES_INFO = {label: "Route Properties", name: "RouteProperties"};
export const HOZ_INFO= {label: "HOZ Route", name: "HozRoute"};

export const RECURRING_HOLIDAY = "Weekly Holidays";
export const NON_RECURRING_HOLIDAY = "Date-Based Holidays";
export const HOLIDAY_TYPE_INPUTS = [RECURRING_HOLIDAY, NON_RECURRING_HOLIDAY];
export const HOLIDAY_CATEGORY_OPTIONS = ["Site Consolidation", "Site Construction", "Colo Loading Dock Unavailable", "Public Holiday"];

export const SITE_SPREAD_COLUMN_INFO = {label: "Site Spread", name: "SiteSpread"};
export const AZ_MAX_COLUMN_INFO = {label: "AZ Max", name: "AzMax"};

export const REGION = "REGION";
export const SUPER_AZ = "SUPER_AZ";
export const AZ = "AZ";
export const SITE = "SITE";
export const ZONE = "ZONE";
export const DEFAULT = "DEFAULT";
export const CLUSTER = "CLUSTER";

// Below values are being hard-coded. We will be exposing these via API going forward.
export const REGION_OPTIONS = ["US","NZ","NED","SW","GR","SYD","BH","DE","CN","TH","IN","CO","UK","FR","ID","KR","LK","ZA",
  "EU","AE","AR","MX","TW","CZ","BZ","FI","HK","JP","SA","MY","ES","AU","IT","NO","GI","PR","CL","CH","SIN","SG","IL","AT","CA", "NRT"];

export const DAYS_INPUT = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY", "DEFAULT"];
export const WEEKDAYS_WITHOUT_WEEKENDS_DAYS_INPUT = DAYS_INPUT.slice(0, 5);
export const WEEKDAYS_WITH_WEEKENDS_DAYS_INPUT = DAYS_INPUT.slice(0,7);

export const LARGEST_SITE_FIRST_WITH_PROMISE_DATE = "largestSiteFirst";
export const IN_STOCK_FIRST_WITH_PROMISE_DATE = "inStockFirstPDAware";
export const PROMISE_DATE_FIRST = "promiseDateFirst";

export const SORTING_ORDERS: Map<string, string> = new Map([
    ["In Stock First With Promise Date", IN_STOCK_FIRST_WITH_PROMISE_DATE],
    ["Promise date first", PROMISE_DATE_FIRST],
    ["Largest site first", LARGEST_SITE_FIRST_WITH_PROMISE_DATE]
]);

export const YES_LABEL = "Yes"
export const NO_LABEL = "No"

export const LOCATION_TYPE_OPTIONS = [REGION, AZ, SITE, CLUSTER];
export const LOCATION_TYPE_OPTION_FOR_RECURRING_HOLIDAYS = [AZ, SITE, CLUSTER];
export const LOCATION_TYPE_OPTIONS_WITHOUT_REGION = [SITE, CLUSTER, SUPER_AZ];
export const LOCATION_TYPE_OPTIONS_FOR_FLEX_DAYS_AND_SITE_SPREAD = [CLUSTER, SUPER_AZ];

export const SOURCE_LOCATION_TYPE = ["ZONE", "SITE"];
export const DESTINATION_LOCATION_TYPE = ["ZONE", "SITE"];
export const PROGRAM_TYPE_OPTIONS = ["RACK", "LOOSE GEAR", "SPARES", "OTHER", "PAC"];
export const ROUTE_TYPE_OPTIONS = AppConfig.getConfigValue(AppConfigMapKey.ENABLE_ROUTE_EXPEDITE) ? [SHIPPING_DETAILS.ROUTE_TYPE_STANDARD, SHIPPING_DETAILS.ROUTE_TYPE_EXPRESS] :
                                          [SHIPPING_DETAILS.ROUTE_TYPE_STANDARD];
export const MOT_OPTIONS = ["GROUND", "AIR", "OCEAN"];
export const ZONES_ALLOWING_SITE_BASED_ROUTING = ["NRT"];
export const YES_NO_RADIO_GROUP_OPTIONS = [YES_LABEL, NO_LABEL]

export const UTC_TIME_START_DAY = "T00:00:00Z";
export const UTC_TIME_END_DAY = "T23:59:59Z";

export const DC_HOLIDAY_CONFIG_ID = "db6736f2-1325-39b7-b65b-f63e46e2eb6f";
export const DC_HOLIDAY_RECORD_NAME = "DC Blocked Days";

export const SITE_SPREAD_CONFIG_ID = "32d4953f-e383-3cd7-828f-3d7ff87436de";
export const SIM_SITE_SPREAD_CONFIG_ID = "96cffbb7-7b88-3142-93aa-96129d20cd92";
export const SITE_SPREAD_RECORD_NAME = "Variable Site Spread";

export const THROUGHPUT_CONFIG_ID = "8f1b7ccc-c21d-364c-afc7-895e37abb2e7";
export const SIM_THROUGHPUT_CONFIG_ID = "a3065e8f-d3e8-350a-aa37-9e8c11a61bbd";
export const THROUGHPUT_RECORD_NAME = "Throughput";

export const FLEX_DAYS_CONFIG_ID = "6a3fffd6-f15d-3fbc-bca5-e80e000969df";
export const SIM_FLEX_DAYS_CONFIG_ID = "8611136c-46ee-31b4-977a-521892685632";
export const FLEX_DAYS_RECORD_NAME = "Flex Days";

export const ROUTE_CONFIG_ID = "83c98c8e-bd46-3d50-b076-3e546c9e67ad"
export const ROUTE_RECORD_NAME = "Route";

export const CONFIGS_ALLOWING_INDEXING_IN_TABLE_ATTRIBUTE = new Set([ROUTE_CONFIG_ID]);
export const CONFIGS_ALLOWING_DISPLAY_ALL_CONFIGS = new Set([ROUTE_CONFIG_ID]);

export const ERRORS = {
  SITE_SPREAD_CONFIG_ERROR : {
    NO_ITEM: "No items added in the Site Spread constraints.",
    SITE_SPREAD_INVALID: (rows: string) => `Site spread is invalid for following row numbers: [${rows}] in Site Spread table.`,
    AZ_MAX_INVALID: (rows: string) => `Az Max is invalid for following row numbers: [${rows}] in Site Spread table.`,
    MISSING_SITE_SPREADS: (siteSpreads: string) => `Following Site Spreads are missing: [${siteSpreads}].`
  },
  THROUGHPUT_CONFIG_ERROR: {
    NO_ITEM: "No items added in the throughput constraints.",
    SITE_SPREAD_ITEM_COUNT: "Exactly one site max should be defined for Sites.",
    SITE_SPREAD_REQUIRED: (days: string) => `Site spread max is required when weekday is:  [${days}].`,
    SITE_AZ_MAX_REQUIRED: "Site Max and Az Max are required when weekday is: DEFAULT.",
    SITE_AZ_MAX_CANNOT_BE_ZERO: "Site Max and Az Max should be greater 0.",
    SITE_SPREAD_MAX_CANNOT_BE_ZERO: "SiteSpread Max should be greater 0.",
    SITE_MAX_NOT_REQUIRED: (days: string) =>  `Site Max not required when weekday is: [${days}].`,
    SITE_MAX_REQUIRED: "Site max is required but not provided.",
    SITE_MAX_CANNOT_BE_ZERO: "Site Max should be greater 0.",
    DAY_NOT_SELECTED: "Day is not selected for one or more throughput constraints.",
    DEFAULT_DAY_INPUT_IS_REQUIRED: "Input for DEFAULT day is required.",
    ALL_WEEKDAYS_REQUIRED: (days: string) => `Throughput not provided for following week days: [${days}].`,
  },
  ROUTE_CONFIGS_ERRORS: {
    AT_LEAST_ONE_CROSS_DOCK: "For Rack Program Type, If the Source and Destination Zones are different, There must be atleast one CrossDock present",
    UNIQUE_CROSS_DOCKS: "Cross Docks need to be unique",
    EMPTY_CROSS_DOCK: "Cross Dock not provided.",
    EMPTY_MOT_CROSS_DOCK: "MOT For Cross Dock not provided.",
    CROSS_DOCK_MOT_PROVIDED_FOR_DEFAULT_ROUTE: "Cross Dock MOTs must not be provided for a Default route.",
    DEFAULT_ROUTE_CROSS_DOCK_ERROR: "There must be exactly one Cross Dock in case of a Default Route.",
    DATES_ABSENT_ERROR: "Dates must be present.",
    NON_RACK_HOZ_ROUTE_ERROR : "HOZ Route is not applicable for Non Rack Program Type"
  },
  REPEATING_DATA : (tableName: string) => `Duplicate rows found in ${tableName}.`,
  CONFIGURATION_ALREADY_EXISTS: (configurationName: string) => `${configurationName} record already exists, Please use search section to edit existing configs.`
}

export const MODAL_CONTENT = {
  PRIMARY_BUTTON_TEXT: "OK",
  DISABLE_MODAL: {
    HEADER: "Deleting Existing Configuration",
    CONTENT: "Are you sure you want to disable the configuration ? Once submitted, the action cannot be undone!"
  },
  UPDATE_MODAL: {
    HEADER: "Submitting Update Request",
    CONTENT: "Are you sure you want to update the configuration ? Once submitted, the action cannot be undone!"
  },
  CREATE_MODAL: {
    HEADER: "Submitting Create Request",
    CONTENT: "Are you sure you want to create the configuration ? Once submitted, the action cannot be undone!"
  }
};

export const BANNER_DETAILS = {
  DISABLE_SUCCESS: {
    CONTENT: 'Disable request successfully processed.',
    BANNER_TYPE: BANNER_TYPE_SUCCESS,
    ID: "DISABLE_SUCCESS",
    LOADING: false
  },
  CREATE_SUCCESS: {
    CONTENT: 'Create request successfully processed.',
    BANNER_TYPE: BANNER_TYPE_SUCCESS,
    ID: "CREATE_SUCCESS",
    LOADING: false
  },
  UPDATE_SUCCESS: {
    CONTENT: 'Update request successfully processed.',
    BANNER_TYPE: BANNER_TYPE_SUCCESS,
    ID: "UPDATE_SUCCESS",
    LOADING: false
  },
  EFFECTIVE_DATES_WARNING: {
    CONTENT: "Effective from and to dates are more than 7 days apart. Please ensure you have selected correct dates.",
    BANNER_TYPE: BANNER_TYPE_WARNING,
    ID: "EFFECTIVE_DATES_WARNING",
    LOADING: false
  },
  REQUEST_IN_PROGRESS: {
    CONTENT: 'Your request is being processed.',
    BANNER_TYPE: BANNER_TYPE_SUCCESS,
    ID: "REQUEST_IN_PROGRESS",
    LOADING: true
  },
  UPDATE_REQUEST_FAILED: {
    BANNER_TYPE: BANNER_TYPE_ERROR,
    ID: "REQUEST_FAILED",
    LOADING: false
  },
  UPDATE_REQUEST_WARNINGS: {
    BANNER_TYPE: BANNER_TYPE_WARNING,
    ID: "REQUEST_WARNINGS",
    LOADING: false
  },
  SEARCH_REQUEST_FAILED: {
    BANNER_TYPE: BANNER_TYPE_ERROR,
    ID: "SEARCH_REQUEST_FAILED",
    LOADING: false
  }
};

export const CONFIG_ID = "ConfigId";
export const CONFIGURATION_TYPES = [
  {label: "DC Blocked Days", value: DC_HOLIDAY_CONFIG_ID, isEnabled: true},
  {label: "Variable Site Spread", value: SITE_SPREAD_CONFIG_ID, isEnabled: true},
  {label: "Throughput", value: THROUGHPUT_CONFIG_ID, isEnabled: true},
  {label: "Flex Days", value: FLEX_DAYS_CONFIG_ID, isEnabled: true},
  {label: "Route", value: ROUTE_CONFIG_ID, isEnabled: AppConfig.getConfigValue(AppConfigMapKey.ENABLE_ROUTE_CONFIG)}
].filter(config => config.isEnabled);

export const SIMULATION_CONFIGURATION_TYPES = [
  {label: "Variable Site Spread (Simulation)", value: SIM_SITE_SPREAD_CONFIG_ID},
  {label: "Throughput (Simulation)", value: SIM_THROUGHPUT_CONFIG_ID},
  {label: "Flex Days (Simulation)", value: SIM_FLEX_DAYS_CONFIG_ID}
] 

export const ALL_CONFIG_TYPES = [...SIMULATION_CONFIGURATION_TYPES, ...CONFIGURATION_TYPES]

export const ACCESS_DENIED_MESSAGE = (configName: string) =>  `You do not have access to the ${configName} data.`;

export const CONFIG_SERVICE_ERROR_MAP: {errorMessageInput: string, output: (input: string) => string}[] =
  [
    {
      errorMessageInput: "AccessDeniedException",
      output: (configName: string) =>  ACCESS_DENIED_MESSAGE(configName)
    },
    {
      errorMessageInput: "NotFoundException",
      output: (configName: string) => "Record being accessed does not exist"
    },
    {
      errorMessageInput: "Found multiple records",
      output: (configName: string) =>  `Request to create/update the ${configName} record was not successful as multiple ${configName} found within provided effective from and to date range.`
    },
    {
      errorMessageInput: "does not match existing configuration data",
      output: (configName: string) => `Request to create/update the ${configName} record was not successful as ${configName} record already exists within the provided effective from and to date range.`
    },
    {
      errorMessageInput: "DuplicateInputException",
      output: (configName: string) =>  `Request to create/update the record was not successful as a ${configName} record already exists with matching effective to and from time.`
    },
    {
      errorMessageInput: "UnknownError: Forbidden",
      output: (configName: string) =>  ACCESS_DENIED_MESSAGE(configName)
    }
  ];

export const CREATE_SEGMENT = "Create Configuration";
export const SEARCH_SEGMENT = "Search Configuration";

export const CREATE_TAB = 'create';
export const SEARCH_TAB = 'search';

export const SEGMENT_OPTIONS = [
  {
    "text": CREATE_SEGMENT,
    "id": CREATE_SEGMENT
  },
  {
    "text": SEARCH_SEGMENT,
    "id": SEARCH_SEGMENT,
  }
]

export const LOADING_SEARCH_RESULT = "Search results";
export const LOADING_EDIT_PAGE = "Edit Page. Please wait.";
export const LOADING_CREATE_PAGE = "Create Page. Please wait."

export const NO_MATCHING_RECORDS_FOUND = "No matching records found.";
export const MULTIPLE_MATCHING_RECORDS_FOUND = "Multiple matching configuration found.";

export const GET_REQUEST_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: "10 resources" },
  { value: 20, label: "20 resources" },
  { value: 40, label: "40 resources" }
];

export const EDIT_PAGE_BREAD_CRUMBS = [
  {
    "text": "Shipments",
    "href": "/shipments"
  },
  {
    "text": "Edit Configuration",
    "href": "/configuration/edit"
  }
];